<template>
  <div class="vue-wrapper-full" style="height: 100%;">
    <!-- Scroll Menu -->
    <div class="sidebar left fixed subnav show-for-large">
      <div class="fixed-container">
        <!-- <scrollactive scrollContainerSelector="#objekt-form" active-class="active" :highlightFirstItem="true" :offset="50" :duration="500" :modifyUrl="false" bezier-easing-value="0.455,0.03,0.515,0.955"> -->
          <ul id="myscrollmenu" style="cursor: pointer;">
            <li><a @click="myScrollTo(0)" class="scrollactive-item scroll-0 active" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-0')}">Innstillinger <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-0')">{{sectionErrors['objekt-section-0']}}</span></a></li>
            <li><a @click="myScrollTo(1)" class="scrollactive-item scroll-1" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-1')}">Kategorier <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-1')">{{sectionErrors['objekt-section-1']}}</span></a></li>
            <li><a @click="myScrollTo(2)" class="scrollactive-item scroll-2" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-2')}">Beskrivelse <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-2')">{{sectionErrors['objekt-section-2']}}</span></a></li>
            <li v-if="useSpecifications"><a @click="myScrollTo(3)" class="scrollactive-item scroll-3" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-3')}">Spesifikasjoner <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-3')">{{sectionErrors['objekt-section-3']}}</span></a></li>
            <li><a @click="myScrollTo(4)" class="scrollactive-item scroll-4" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-4')}">Vurdering <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-4')">{{sectionErrors['objekt-section-4']}}</span></a></li>
            <li v-if="isAECategory"><a @click="myScrollTo(5)" class="scrollactive-item scroll-5" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-5')}">Auksjonsmerknad <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-5')">{{sectionErrors['objekt-section-5']}}</span></a></li>
            <li><a @click="myScrollTo(6)" class="scrollactive-item scroll-6" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-6')}">Salær <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-6')">{{sectionErrors['objekt-section-6']}}</span></a></li>
            <li><a @click="myScrollTo(7)" class="scrollactive-item scroll-7" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-7')}">Rettelse <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-7')">{{sectionErrors['objekt-section-7']}}</span></a></li>
            <li><a @click="myScrollTo(8)" class="scrollactive-item scroll-8" :class="{'error': sectionErrors.hasOwnProperty('objekt-section-8')}">Media <span class="count" v-if="sectionErrors.hasOwnProperty('objekt-section-8')">{{sectionErrors['objekt-section-8']}}</span></a></li>
          </ul>
        <!-- </scrollactive> -->
      </div>
    </div>
    <!-- End scroll -->

    <overlay-scrollbars ref="myScrollBar" :options="{ className: 'content status-sidebar custom-scrollbar os-theme-dark', callbacks: { onScrollStop: onScrollStop }, scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <div id="objekt-form" class="content-container flex-row">

        <section class="content medium-padding fixed-width small scrollnav">
          <form @submit.prevent="handleSubmit">
            <div class="scroll-section" id="objekt-section-0">
              <h2>Innstillinger</h2>

              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheSelectInput data-vv-validate-on="input" v-model="form.Objekttype" containerClassName="cell medium-6" label="Objekttype" name="Objekttype" required v-validate="'required'" :items="objDropdown" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>
                  <TheSelectInput data-vv-validate-on="input" v-model="form.Avdelingsid" containerClassName="cell medium-6" label="Avdeling" name="Avdelingsid" required v-validate="'required'" :items="avdDropdown" :disabled="true"/>
                  <TheSelectInput data-vv-validate-on="input" v-model="form.Expertavdelingsid" containerClassName="cell medium-6" label="Ekspertavdeling" name="Expertavdelingsid" required v-validate="'required'" :items="expDropdown" :disabled="!isPresenceOwner || form.Avdelingsid === null || form.Avdelingsid === '' || expDropdown.length <= 1 || $store.getters.isFormLoading"/>
                  <TheSelectInput data-vv-validate-on="input" v-model="form.Lokasjonid" containerClassName="cell medium-6" label="Lokasjon" name="Lokasjon" required v-validate="'required'" :items="lokasjonDropdown" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>

                  <div class="cell large-12">
                    <label for="Lev_dato">Utlevert dato <span v-show="requireLevDato">*</span></label>
                    <div class="input-container date dropdown-top">
                      <b-datepicker
                        :show-week-number="false"
                        :editable="false"
                        :first-day-of-week="1"
                        :disabled="!isPresenceOwner || !form.Lokasjonid || !(parseInt(form.Lokasjonid) === 159 || parseInt(form.Lokasjonid) === 327)"
                        v-validate="{'required': requireLevDato}"
                        v-model="form.Lev_dato"
                        name="Lev_dato"
                        placeholder="Vis kalender..."
                        icon="calendar-today"
                        ref="Lev_dato"
                        id="Lev_dato">
                      </b-datepicker>
                      <span class="glyph"><svg viewBox="0 0 44 44"><use
                        xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    </div>
                  </div>

                  <TheAutoCompleteInput v-model.trim="form.Auksjon" :disabled="!isPresenceOwner || isAuksjonDisabled" containerClassName="cell large-12" name="Auksjon" maxlength="10" required v-validate="'required|max:10'" :placeholder="'Velg auksjon'" :label="'Tilhørende auksjon'" :onInputCallback="onAuksjonSearchInput" :onSelectCallback="onAuksjonSearchSelected" :onCreateCallback="openAuksjonModal" :onUpdateCallback="openAuksjonModal" :debounce="750" :minquery="2">
                    <div slot="item" slot-scope="props">
                      <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
                      <span v-if="props.item.Auksjon_dato">
                        ({{ props.item.Auksjon_dato | avantidate }})
                      </span>
                    </div>
                  </TheAutoCompleteInput>

                  <TheSelectInput data-vv-validate-on="input" v-model="form.Fraktgruppeid" containerClassName="cell medium-6" label="Fraktgruppe" name="Fraktgruppe" :items="fraktgruppeDropdown" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>
                  <TheDecimalInput containerClassName="cell medium-6" symbol=kr label="Auksjonshonorar" name="Fotokostnad" v-model.trim="form.Fotokostnad" maxlength="10" v-validate="'max:10|decimal'" :disabled="!isPresenceOwner"/>

                  <TheSwitchInput v-model="form.Oppgjorgodkjendt" containerClassName="cell large-6" align="left" labelTrue="Oppgjør godkjent" labelFalse="Oppgjør godkjent" :trueValue="'T'" :falseValue="'F'" :disabled="!isPresenceOwner"/>
                  <TheSwitchInput v-model="form.Lagerleieinfo" containerClassName="cell medium-6" align="left" labelTrue="Lagerleie" labelFalse="Lagerleie" :trueValue="1" :falseValue="0" :disabled="!isPresenceOwner"/>

                  <TheTextArea v-if="isSentrum" containerClassName="cell large-12" label="Rettelse" placeholder="Rettelser til tekst i trykket katalog…" name="Rettelse" v-model="form.Rettelse" :rows="3" maxlength="500" v-validate="'max:500'" :disabled="!isPresenceOwner"/>
                  <TheIntegerInput v-if="isSentrum" containerClassName="cell large-12" label="Katalognr" placeholder="Katalognr…" name="Katalognr" v-model="form.Katalognr" :disabled="!isPresenceOwner"/>
                </div>
              </fieldset>
            </div>

            <div class="scroll-section" id="objekt-section-1">
              <h2>Kategorier</h2>

              <div v-if="isVin">
                <fieldset class="card">

                  <div class="grid-x grid-padding-x">
                    <TheIntegerInput containerClassName="cell medium-6 large-6" label="Årgang" placeholder="Årgang" name="Argang" v-model.trim="form.Argang" maxlength="4" v-validate="'min:4|max:4'" :disabled="!isPresenceOwner"/>

                    <TheSelectInput v-model="form.Kategori" containerClassName="cell medium-6 large-6" label="Kategori" name="Kategori" v-validate="'required'" data-vv-validate-on="input" :items="catDropdown" :disabled="!isPresenceOwner || form.Expertavdelingsid === null || form.Expertavdelingsid === '' || catDropdown.length <= 1 || $store.getters.isFormLoading"/>

                    <div class="cell medium-12 large-12" v-if="form.Kategori && subCatTreeDropdown">
                      <!-- :alwaysOpen="true" when testing -->
                      <template v-if="!isPresenceOwner || $store.getters.isFormLoading || subCatTreeDropdown.length < 1">
                        <label for="">Underkategori</label>
                        <div class="input-container text">
                          <input type="text" :value="$store.getters.isFormLoading ? 'Laster...' : 'Ingen underkategori'" disabled/>
                        </div>
                      </template>
                      <template v-else>
                        <label for="">Underkategori</label>
                        <treeselect v-model="form.KategoriLabels" :flat="true" :autoSelectAncestors="true" :autoDeselectDescendants="true" :sort-value-by="'INDEX'" :multiple="true" :options="subCatTreeDropdown"/>
                      </template>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div v-if="!isVin">
                <fieldset class="card">
                  <div class="grid-x grid-padding-x">
                    <TheSelectInput v-model="form.Kategori" containerClassName="cell large-6" label="Hovedkategori" name="Kategori" required v-validate="'required'" :items="catDropdown" :disabled="!isPresenceOwner || form.Expertavdelingsid === null || form.Expertavdelingsid === '' || catDropdown.length <= 1 || $store.getters.isFormLoading"/>
                    <TheSelectInput v-model="form.KategoriLabels" containerClassName="cell large-6" label="Underkategori" name="KategoriLabels" :items="subCatDropdown" :disabled="!isPresenceOwner || form.Kategori === null || form.Kategori === '' || subCatDropdown.length <= 1 || $store.getters.isFormLoading"/>
                  </div>

                  <div class="grid-x grid-padding-x">
                    <div class="cell large-12">
                      <div class="divider"></div>
                    </div>
                  </div>

                  <div class="grid-x grid-padding-x">
                    <TheSelectInput v-model="form.KategoriSekundaer" containerClassName="cell large-6" label="Sekundær Kategori" name="KategoriSekundaer" :items="kategoriSekundaerDropdown" :disabled="!isPresenceOwner || form.Expertavdelingsid === null || form.Expertavdelingsid === '' || catDropdown.length <= 1 || $store.getters.isFormLoading"/>
                  </div>

                  <div class="grid-x grid-padding-x">
                    <div class="cell large-12">
                      <div class="divider"></div>
                    </div>
                  </div>

                  <div class="grid-x grid-padding-x">
                    <div class="cell large-12">
                      <TheTagsAutoCompleteInput v-model.trim="form.tagsString" name="Tags" containerClassName="cell large-12" :disabled="!isPresenceOwner || $store.getters.isFormLoading" :placeholder="'Tagger...'" :label="'Tagger'" :onInputCallback="onTagSearchInput" :onSelectCallback="onTagSelected" :debounce="750" :minquery="2">
                        <div slot="item" slot-scope="props">
                          {{props.item.val}}
                        </div>
                      </TheTagsAutoCompleteInput>
                    </div>
                  </div>

                </fieldset>
              </div>
            </div>

            <div class="scroll-section" id="objekt-section-2">
              <h2>Beskrivelse</h2>

              <fieldset class="card form-line-container">
                <div class="grid-x grid-padding-x">
                  <TheAutoCompleteInput v-show="!isVin" v-model.trim="form.Kunstner" name="Kunstner" :disabled="!isPresenceOwner" v-validate="{ required: this.form.Expertavdelingsid == 2 || this.form.Expertavdelingsid == 5 }" containerClassName="cell large-12" :placeholder="'Søk etter kunstner / designer…'" :label="'Kunstner / designer'" :onInputCallback="onKunstnerSearchInput" :onSelectCallback="onKunstnerSearchSelected" :onCreateCallback="openKunstnerModal" :onUpdateCallback="openKunstnerModal" :onResetCallback="onKunstnerReset" :debounce="750" :minquery="2">
                    <div slot="item" slot-scope="props">
                      <span v-if="props.item.val">
                        {{ props.item.val }}<span v-if="props.item.period">, {{ props.item.period }}</span>
                      </span>
                      <span v-else>
                        {{ props.item.key }}<span v-if="props.item.period">, {{ props.item.period }}</span>
                      </span>
                    </div>
                  </TheAutoCompleteInput>

                  <TheTextInput containerClassName="cell large-6 xlarge-8" :label="titleLabel" name="Katalogtekst1" v-model.trim="form.Katalogtekst1" maxlength="100" v-validate="'max:100'" :disabled="!isPresenceOwner"/>
                  <TheIntegerInput containerClassName="cell large-3 xlarge-2" label="Antall" symbol="stk" name="Antall" v-model.trim="form.Antall" maxlength="10" v-validate="'max:10'" :disabled="!isPresenceOwner"/>
                  <TheIntegerInput containerClassName="cell large-3 xlarge-2" label="Etiketter" symbol="stk" name="Antalletikett" v-model.trim="form.Antalletikett" maxlength="10" v-validate="'max:10'" :disabled="!isPresenceOwner"/>

                  <TheTextInput v-show="isVin" containerClassName="cell large-12" label="Produsent" name="producer" v-model.trim="form.producer" maxlength="100" v-validate="'max:100'" :disabled="!isPresenceOwner"/>

                  <TheTextArea containerClassName="cell large-12" label="Beskrivelse/stilperiode" placeholder="Kort beskrivelse av objektet…" name="Objekt3" v-model="form.Objekt3" :rows="3" :autoResize="true" maxlength="100" :required="isVin ? false : true" v-validate="{required: isVin ? false : true, max: 100}" :disabled="!isPresenceOwner"/>

                  <!-- A-E have signert before Tekst -->
                  <template v-if="isAECategory">
                    <template v-if="!isVin">
                      <TheSelectInput containerClassName="cell large-12" v-model="form.signert" name="signert" label="Signeringssted" :items="sigDropdown" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>
                      <TheTextInput containerClassName="cell large-12" label="Signert" name="Objekt1" :inputLabel="signertText" v-model="form.Objekt1" maxlength="100" v-validate="'max:100'" :disabled="!isPresenceOwner"/>
                    </template>

                    <TheTextArea containerClassName="cell large-12" label="Tekst" placeholder="Utfyllende beskrivelse av objektet…" name="Katalogtekst2" v-model="form.Katalogtekst2" :rows="3" :autoResize="true" :disabled="!isPresenceOwner"/>
                  </template>
                  <template v-else>
                    <TheTextArea containerClassName="cell large-12" label="Tekst" placeholder="Utfyllende beskrivelse av objektet…" name="Katalogtekst2" v-model="form.Katalogtekst2" :rows="3" :autoResize="true" :disabled="!isPresenceOwner"/>

                    <template v-if="!isVin">
                      <TheSelectInput containerClassName="cell large-12" v-model="form.signert" name="signert" label="Signeringssted" :items="sigDropdown" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>
                      <TheTextInput containerClassName="cell large-12" label="Signert" name="Objekt1" :inputLabel="signertText" v-model="form.Objekt1" maxlength="100" v-validate="'max:100'" :disabled="!isPresenceOwner"/>
                    </template>

                    <TheSelectInput v-if="!isVin && form.Expertavdelingsid" containerClassName="cell large-12" v-model="merknadPreset" name="MerknadPreset" label="Førhåndsdefiniert merknad" :items="merknadDropdownOptions" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>
                    <TheTextArea containerClassName="cell large-12" label="Auksjonsmerknad" placeholder="Merknad til auksjon…" name="NettMerknad" v-model="form.NettMerknad" :rows="3" maxlength="5000" v-validate="'max:5000'" :disabled="!isPresenceOwner"/>
                  </template>
                </div>
              </fieldset>
            </div>

            <input type="hidden" name="spec" v-model.trim="hasSelectedSpec" v-if="!useSpecifications">
            <div class="scroll-section" id="objekt-section-3" v-if="useSpecifications">
              <h2>Spesifikasjoner</h2>

              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheSwitchInput v-model="form.spesifikasjoner" containerClassName="cell large-6" align="left" labelTrue="Objekt har ikke spesifikasjoner" labelFalse="Objekt har spesifikasjoner" :disabled="!isPresenceOwner" :trueValue="false" :falseValue="true"/>

                  <div class="cell large-6">
                    <div class="input-container checkbox" :class="{'form-error': errors.has('spec')}">
                      <input type="hidden" name="spec" v-model.trim="hasSelectedSpec" value="1" v-validate="'max: 4'">
                      <span class="form-error-label" style="text-align: left; position: initial;" v-if="errors.has('spec')">
                        Fyll inn minst en spesifikasjon
                      </span>
                    </div>
                  </div>
                </div>

                <template v-if="form.spesifikasjoner">
                  <div class="grid-x grid-padding-x">
                    <template v-for="(item, index) in specChoosenSizes">
                      <TheTextArea v-bind:key="index + '_' + item.name" v-if="specOptionsSizes[item.name].type === 'textarea'" containerClassName="cell small-8 medium-9 large-9" :name="item.name" :label="item.label" v-model="item.value.item" :rows="3" maxlength="255" v-validate="'max:255'" :disabled="!isPresenceOwner"/>
                      <TheTextInput v-bind:key="index + '_' + item.name" v-else-if="specOptionsSizes[item.name].type === 'text'" containerClassName="cell small-8 medium-3 large-3" :name="item.name" :label="item.label" v-model.trim="item.value.item" maxlength="255" v-validate="'max:255'" :disabled="!isPresenceOwner"/>
                      <TheSpecInput v-bind:key="index + '_' + item.name" v-else-if="specOptionsSizes[item.name].type !== 'text' && !specOptionsSizes[item.name].unitOptions" containerClassName="cell small-8 medium-3 large-3" :name="item.name" :label="item.label" v-model="item.value" maxlength="25" v-validate="'max:25'" :disabled="!isPresenceOwner"/>
                      <TheSpecInput v-bind:key="index + '_' + item.name" v-else-if="specOptionsSizes[item.name].type !== 'text' && specOptionsSizes[item.name].unitOptions.length > 1" containerClassName="cell small-8 medium-3 large-3" :pickerOptions="specOptionsSizes[item.name].unitOptions" :name="item.name" :label="item.label" v-model="item.value" :disabled="!isPresenceOwner" maxlength="25" v-validate="'max:25'"/>
                      <TheSpecInput v-bind:key="index + '_' + item.name" v-else-if="specOptionsSizes[item.name].type !== 'text' && specOptionsSizes[item.name].unitOptions.length === 1" containerClassName="cell small-8 medium-3 large-3" :symbol="specOptionsSizes[item.name].unitOptions[0]" :name="item.name" :label="item.label" v-model="item.value" :disabled="!isPresenceOwner" maxlength="25" v-validate="'max:25'"/>

                      <div v-bind:key="index + '_delete_button'" class="cell small-4 medium-3 large-3">
                        <label>&nbsp;</label>
                        <div class="input-container">
                          <a v-if="isPresenceOwner" href="javascript:;" @click="delSpecSizeItem(index)" class="button action input-action glyph glyph-only delete-form-line"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg></a>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="grid-x grid-padding-x" v-if="getSpecOptionsSizes.length > 0">
                    <div class="cell large-12">
                      <span class="button-container has-popover" :class="{'popover-active': specPopoverActive}" @click="toggleSpecPopover()">
                        <a href="javascript:;" class="button action glyph" :class="{'disabled':  !isPresenceOwner}"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Ny spesifikasjon</span></a>
                        <span class="popover align-x-center align-y-top medium">
                          <ul>
                            <li v-for="item in getSpecOptionsSizes" v-bind:key="'add-' + item.name">
                              <a href="javascript:;" @click="addSpecSizeItem(item)" class="add-form-line popover-form-line"><span>{{item.label}}</span></a>
                            </li>
                          </ul>
                        </span>
                      </span>
                    </div>
                  </div>
                </template>
              </fieldset>
            </div>

            <div class="scroll-section" id="objekt-section-4">
              <h2>Vurdering</h2>

              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheDecimalInput containerClassName="cell medium-4" label="Lav vurdering" name="Vurderingspris2" symbol="kr" v-model.trim="form.Vurderingspris2" maxlength="10" v-validate="'max:10|decimal|checkVurdering'" :disabled="!isPresenceOwner"/>
                  <TheDecimalInput containerClassName="cell medium-4" label="Høy vurdering" name="Vurderingspris1" symbol="kr" v-model.trim="form.Vurderingspris1" maxlength="10" v-validate="'max:10|decimal|checkVurdering'" :disabled="!isPresenceOwner"/>
                  <TheDecimalInput containerClassName="cell medium-4" label="Minstepris" name="Minstepris" symbol="kr" v-model.trim="form.Minstepris" maxlength="10" v-validate="{max: 10, decimal: true, checkMinstepris: form.Vurderingspris2 > 0 && form.Vurderingspris1 > 0, required: form.Vurderingspris2 > 0 && form.Vurderingspris1 > 0 }" :disabled="!isPresenceOwner"/>
                </div>
              </fieldset>
            </div>

            <div v-if="isAECategory" class="scroll-section" id="objekt-section-5">
              <h2>Auksjonsmerknad</h2>
              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheSelectInput v-if="!isVin && form.Expertavdelingsid" containerClassName="cell large-12" v-model="merknadPreset" name="MerknadPreset" label="Førhåndsdefiniert merknad" :items="merknadDropdownOptions" :disabled="!isPresenceOwner || $store.getters.isFormLoading"/>
                  <TheTextArea containerClassName="cell large-12" label="Auksjonsmerknad" placeholder="Merknad til auksjon…" name="NettMerknad" v-model="form.NettMerknad" :rows="3" maxlength="5000" required v-validate="'max:5000'" :disabled="!isPresenceOwner"/>
                </div>
              </fieldset>
            </div>

            <div class="scroll-section" id="objekt-section-6">
              <h2>Salær</h2>
              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheDecimalInput containerClassName="cell medium-12" label="Salær" name="Salar" symbol="%" v-model.trim="form.Salar" maxlength="10"  v-validate="'max:10|decimal'" :disabled="!isPresenceOwner"/>
                </div>
              </fieldset>
            </div>

            <div class="scroll-section" id="objekt-section-7">
              <h2>Rettelse</h2>
              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheTextArea containerClassName="cell large-12" label="Rettelse" placeholder="Rettelse" name="Rettelse" v-model="form.Rettelse" :rows="3" maxlength="499" v-validate="'max:499'" :disabled="!isPresenceOwner"/>
                </div>
              </fieldset>
            </div>

            <div class="scroll-section" id="objekt-section-8">
              <h2>Media</h2>
              <fieldset class="card">
                <div class="grid-x grid-padding-x">
                  <TheTextInput containerClassName="cell medium-12" label="Vimeo video" name="video" v-model.trim="form.video" maxlength="255" v-validate="'max:255'" :disabled="!isPresenceOwner"/>
                </div>
              </fieldset>
            </div>
          </form>
        </section>

        <div class="sidebar fixed medium right">
          <div class="fixed-container">
            <div class="sidebar-content-container">
              <fieldset class="card">
                <div class="form-line-container">
                  <div class="grid-x form-line border fixed-height show-for-xxlarge">
                    <div class="cell auto">Objektnr</div>
                    <div class="cell shrink">
                      <span class="opacity-60">{{objekt.Objektnr}}</span>
                    </div>
                  </div>
                  <div class="grid-x form-line border">
                    <div class="cell auto">Status</div>
                    <div class="cell shrink">
                      <span class="opacity-60">{{objekt.Tekst_ok === 'F' ? 'Kladd' : 'Godkjent'}}</span>
                    </div>
                  </div>
                  <div class="grid-x form-line border fixed-height">
                    <div class="cell auto">Sist oppdatert</div>
                    <div class="cell shrink"><span class="opacity-60">{{objekt.Sist_endret_tid | avantidatetime}}</span></div>
                  </div>
                  <div class="grid-x form-line border fixed-height">
                    <div class="cell auto">Sist oppdatert av</div>
                    <div class="cell shrink">
                      <span class="opacity-60">{{objekt.Sist_endret_av}}</span>
                    </div>
                  </div>
                  <div class="grid-x form-line border fixed-height show-for-xxlarge">
                    <div class="cell auto">Nåværende auksjon</div>
                    <div class="cell shrink">
                      <span class="opacity-60">{{objekt.Auksjon ? objekt.Auksjon : '-'}}</span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </overlay-scrollbars>

  </div>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import KunstnerService from '@/services/KunstnerService'
import KundeService from '@/services/KundeService'
import AuksjonService from '@/services/AuksjonService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import TheSpecInput from '../Inputs/TheSpecInput'
import TheTagsAutoCompleteInput from '../Inputs/TheTagsAutoCompleteInput'
import bus from '@/plugins/event-bus'
import moment from 'moment'

export default {
  name: 'KundeKontraktObjektForm',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput,
    TheTagsAutoCompleteInput,
    TheSpecInput
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      lastLokId: 0,
      form: {},
      original: {},
      originalSpec: [],
      sectionErrors: {},
      objDropdown: [], // Objekt type drowdown
      avdDropdown: [], // Avdeling dropdown
      fgrDropdown: [], // Fraktgruppe
      expList: [], // Expertavdeling
      catList: [], // Categories
      lblList: [], // Labels
      tagList: [], // Tags
      lokDropdown: [],
      sigDropdown: [],
      merknadDropdown: [],
      merknadPreset: null,
      instillinger: {
        mfgs: [
          // Med förbehåll om selgers Godkännande
          {key: null, val: 'Velg med forbehold selgers godkjennelse'},
          {key: 'G', val: 'G'},
          {key: 'M', val: 'M'}
        ]
      },
      signertText: '',
      specOptionsSizes: {
        Antatt_kvalitet: { name: 'Antatt_kvalitet', label: 'Antatt kvalitet', type: 'textarea', expertavdeling: [6] },
        Vekt: { name: 'Vekt', label: 'Totalvekt', unitOptions: ['g', 'kg'], defaultUnit: 0, type: 'decimal', expertavdeling: [6] },

        Ringstorrelse: { name: 'Ringstorrelse', label: 'Ringstørrelse', type: 'decimal', expertavdeling: [6] },
        Karat: { name: 'Karat', label: 'Karat', unitOptions: ['kt'], defaultUnit: 0, type: 'decimal', expertavdeling: [6] },
        Assuranseverdi: { name: 'Assuranseverdi', label: 'Assuranseverdi', unitOptions: ['kr'], defaultUnit: 0, type: 'decimal', expertavdeling: [6] },

        Hoyde: { name: 'Hoyde', label: 'Høyde', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [2, 5, 4, 6] },
        Bredde: { name: 'Bredde', label: 'Bredde', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [2, 5, 4, 6] },
        Lengde: { name: 'Lengde', label: 'Lengde', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [2, 5, 4, 6] },
        Dybde: { name: 'Dybde', label: 'Dybde', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [2, 5, 4, 6] },
        Diameter: { name: 'Diameter', label: 'Diameter', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [2, 5, 4, 6] },

        // Kan visas för kunst
        Papirmal: { name: 'Papirmal', label: 'Papirmål', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [], extraFor: [2, 5] },
        Lysmal: { name: 'Lysmal', label: 'Lysmål', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [], extraFor: [2, 5] },
        Trykkmal: { name: 'Trykkmal', label: 'Trykkmål', unitOptions: ['mm', 'cm'], defaultUnit: 1, type: 'decimal', expertavdeling: [], extraFor: [2, 5] },

        // Kan visas endast för gjendtand
        Sittehoyde: { name: 'Sittehoyde', label: 'Sittehøyde', unitOptions: ['cm'], defaultUnit: 0, type: 'decimal', expertavdeling: [4] }
      },
      specChoosenSizes: {},
      specPopoverActive: false,
      presenceChannelName: null
    }
    /*
    Expertavdeling
      Kunst: 2, 5
      Gjenstand: 4
      Smykker: 6
      Vin: 7
    */
  },
  mounted () {
    // Listen to submit form event from parent - cus button is in parent
    bus.$on('auksjon-saved', (data) => this.onAuksjonSaved(data))
    bus.$on('kunstner-saved', (data) => this.onKunstnerSaved(data))
    bus.$on('objekt-form-submit', (data) => this.handleSubmit(data))

    this.lastLokId = Number(localStorage.new_obj_lokasjonid || 0)
    this.checkDisableAuksjonClear()
  },
  created () {
    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

    // Must turn off the event listener in case it is already there...
    bus.$off('auksjon-saved')
    bus.$off('kunstner-saved')
    bus.$off('objekt-form-submit')

    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.specPopoverActive = false
      }
    })

    // Custom rules
    this.$validator.extend('checkVurdering', {
      validate: this.checkVurdering,
      getMessage: (field, params, data) => data ? data.message : 'Feil vurdering'
    })

    this.$validator.extend('checkMinstepris', {
      validate: this.checkMinstepris,
      getMessage: (field, params, data) => data ? data.message : 'Feil minstepris'
    })

    // Set form not submittable
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  watch: {
    'form': {
      handler (newVal, oldVal) {
        // Check if something has changed in the form

        // var self = this
        // var diff = this._.omitBy(newVal, function(v, k) {
        //   return self.original[k] === v;
        // });
        // console.log(diff)

        if (this.isFormSubmittable() && !this._.isEqual(newVal, this.original)) {
          this.setFormDirty('objektform', true)
        } else {
          this.setFormDirty('objektform', false)
        }
      },
      deep: true
    },
    'specChoosenSizes': {
      // Same as above, but for spesifikasjoner
      handler (newVal, oldVal) {
        if (this.isFormSubmittable() && !this._.isEqual(this.specChoosenSizes, this.originalSpec)) {
          this.setFormDirty('objektform', true)
        } else {
          this.setFormDirty('objektform', false)
        }
      },
      deep: true
    },
    'errors.items': function () {
      let vm = this
      let jq = window.jQuery

      // console.log(this.errors.items)
      setTimeout(() => {
        // Reset errors
        vm.sectionErrors = {}

        if (jq('.form-error').length) {
          jq('.form-error').each(function () {
            let section = jq(this).closest('.scroll-section')

            vm.sectionErrors[section.attr('id')] = jq('.form-error', section).length
          })
        }
      })
    },
    'form.spesifikasjoner': function (newVal) {
      if (newVal !== undefined) {
        if (this.useSpecifications) {
          this.$validator.validate('spec')
        }
      }
    },
    'hasSelectedSpec': function (newVal) {
      if (this.useSpecifications) {
        this.$validator.validate('spec')
      }
    },
    'objekt': function (newVal, oldVal) {
      if (newVal.Objektid !== oldVal.Objektid) {
        // Set form not submittable
        this.setFormLoading(true)

        // Reset
        this.objDropdown = [] // Objekt type drowdown
        this.avdDropdown = [] // Avdeling dropdown
        this.fgrDropdown = [] // Fraktgruppe
        this.expList = [] // Expertavdeling
        this.catList = [] // Categories
        this.lblList = [] // Labels
        this.lokDropdown = []
        this.sigDropdown = []

        // Make the form object
        this.makeFormItem()

        // Load data needed in the form
        this.fetch()
      }
    },
    'form.Avdelingsid': function (newVal, oldVal) {
      if (oldVal !== undefined) {
        this.form.Expertavdelingsid = null
        this.form.Kategori = null
        this.form.KategoriSekundaer = null

        // If only have one Expertavdeling option (+ the disabled "Velg option")
        if (this.expDropdown.length === 2) {
          this.form.Expertavdelingsid = this.expDropdown[this.expDropdown.length - 1].key
        }

        // Reset Underkategori
        this.form.KategoriLabels = this.isVin ? [] : null

        // ...Also reset Extrakategori - as it is based on selected Avdelingsid
        this.form.AddonKategoriList = []

        // Reset Frakgruppe
        this.form.Fraktgruppeid = null

        // Reset Rettelse and Katalognr
        this.form.Rettelse = null
        this.form.Katalognr = null
      }
    },
    'form.Expertavdelingsid': function (newVal, oldVal) {
      if (oldVal !== undefined) {
        if (!newVal) {
          this.form.Kategori = null
          this.form.KategoriSekundaer = null
        }

        // If only have one Hovedkategori option (+ the disabled "Velg option")
        if (this.catDropdown.length === 2) {
          this.form.Kategori = this.catDropdown[this.catDropdown.length - 1].key
        }

        // Reset Underkategori
        this.form.KategoriLabels = this.isVin ? [] : null
      } else if (!newVal) {
        this.form.Kategori = null
        this.form.KategoriSekundaer = null
      }

      // Keep / delete specifications...
      let eid = parseInt(newVal)

      Object.keys(this.specOptionsSizes).forEach((e) => {
        if (this.specChoosenSizes.hasOwnProperty(e) && this.specChoosenSizes[e].value && this.specChoosenSizes[e].value.item) {
          // Has a value, so we keep this one...
        } else if (this.specOptionsSizes[e].expertavdeling.includes(eid)) {
          // If it belongs to this expertavdeling, we keep it with a null value
          let pv = this.specOptionsSizes[e].hasOwnProperty('defaultUnit') ? this.specOptionsSizes[e].defaultUnit : 0
          this.$set(this.specChoosenSizes, e, {name: e, label: this.specOptionsSizes[e].label, value: {item: '', picker: pv}})
        } else {
          // Doesn't belong, so we delete it
          this.$delete(this.specChoosenSizes, e)
        }
      })

      if (this.useSpecifications) {
        this.$validator.validate('spec')
      }
    },
    'form.Kategori': function (newVal, oldVal) {
      if (oldVal !== undefined) {
        // Reset Underkategori
        this.form.KategoriLabels = this.isVin ? [] : null
      }

      if (newVal !== undefined) {
        if (!this.useSpecifications) {
          this.form.spesifikasjoner = false
        }
      }

      this.$validator.validate('Kategori')
    },
    'form.signert': function (newValue, oldValue) {
      if (newValue && this.sigDropdown.length > 0) {
        let selected = parseInt(newValue)

        let found = this._.findIndex(this.sigDropdown, function (o) {
          return o.key === selected
        })

        if (found >= 0) {
          this.signertText = this.sigDropdown[found].val
          if (this.form.Objekt1 && this.form.Objekt1.length > 0) {
            this.form.Objekt1 = this.form.Objekt1.replace(this.signertText, '').trim()
          } else {
            this.form.Objekt1 = ''
          }
        }

        if (oldValue === null) {
          // Fix for Objekt1 value in the original variable
          this.original.Objekt1 = this._.clone(this.form.Objekt1)
        }
      } else {
        this.signertText = ''
      }
    },
    merknadPreset: function (newValue) {
      if (newValue) {
        let vm = this
        let found = this.merknadDropdown.find(i => i.key === parseInt(newValue))

        if (found && found.val && found.val.length > 0) {
          if (!this.form.NettMerknad) {
            this.form.NettMerknad = found.val
          } else {
            this.form.NettMerknad += '\n' + found.val
          }

          setTimeout(() => {
            vm.merknadPreset = null
          }, 1500)
        }
      }
    },
    'form.Lokasjonid': function (newVal, oldVal) {
      if (newVal) {
        if (newVal === '159' || newVal === 159 || newVal === '327' || newVal === 327) {
          if (oldVal !== undefined) {
            this.$set(this.form, 'Lev_dato', new Date())
          }
        } else {
          this.$set(this.form, 'Lev_dato', null)
        }
      }
    },
    'form.Auksjon': function (newVal, oldVal) {
      if (newVal !== this.original.Auksjon) {
        this.form.Katalognr = null
      } else {
        this.form.Katalognr = this.original.Katalognr
      }
    }
  },
  computed: {
    isPresenceOwner: function () {
      if (this.avantiEnv === 'local' || this.avantiEnv === 'staging') {
        return true
      }
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    },
    lokasjonDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.objekt.Lokasjonid, val: 'Laster...'})
        return retval
      }

      if (this.lastLokId || this.form.Lokasjonid) {
        // Find last && curr in array
        const last = this.lastLokId ? this.lokDropdown.find(x => x.key === this.lastLokId) : false
        const curr = this.form.Lokasjonid ? this.lokDropdown.find(x => x.key === this.form.Lokasjonid) : false

        if (last || curr) {
          // Remove last && curr from array
          const rest = this.lokDropdown.filter(el => {
            return el.key !== this.lastLokId && el.key !== this.form.Lokasjonid
          })

          // Add the rest to return value
          retval = rest

          // Now add top the top of array, in reverse order...
          retval.unshift({key: null, val: '-------------', disabled: true})

          if (last && curr) {
            // Both exists, add one and then the other if not the same
            retval.unshift({key: last.key, val: last.val})

            if (last.key !== curr.key) {
              retval.unshift({key: curr.key, val: curr.val})
            }
          } else if (last) {
            retval.unshift({key: last.key, val: last.val})
          } else if (curr) {
            retval.unshift({key: curr.key, val: curr.val})
          }

          retval.unshift({key: null, val: 'Velg lokasjon', disabled: true})

          return retval
        }
      }

      retval = this.lokDropdown
      retval.unshift({key: null, val: 'Velg lokasjon', disabled: true})

      return retval
    },
    requireLevDato: function () {
      const val = parseInt(this.form.Lokasjonid)
      return val === 159 || val === 327
    },
    isAuksjonDisabled: function () {
      if (new Date() >= new Date(this.objekt.na_max_start) && new Date() <= new Date(this.objekt.na_max_slutt)) {
        return true
      }
      // Admins can always change auksjonkode
      if (this.hasAccess('admin')) {
        return false
      }

      // Disabled if have Salgbilagsnr
      return !!this.objekt.Salgbilagsnr
    },
    titleLabel: function () {
      let expertavd = parseInt(this.form.Expertavdelingsid || 0)

      // Kunst
      if (expertavd === 2 || expertavd === 5) {
        return 'Tittel'
      } else {
        return 'Tittel/Objekt'
      }
    },
    getSpecOptionsSizes: function () {
      let retval = []

      let eid = parseInt(this.form.Expertavdelingsid)

      Object.keys(this.specOptionsSizes).forEach((e) => {
        if (!this.specChoosenSizes.hasOwnProperty(e)) {
          if (this.specOptionsSizes[e].hasOwnProperty('extraFor') && this.specOptionsSizes[e].extraFor.includes(eid)) {
            retval.push(this.specOptionsSizes[e])
          } else if (this.specOptionsSizes[e].hasOwnProperty('expertavdeling') && this.specOptionsSizes[e].expertavdeling.includes(eid)) {
            retval.push(this.specOptionsSizes[e])
          }
        }
      })

      return retval
    },
    hasSelectedSpec: function () {
      if (!this.useSpecifications || !this.form.spesifikasjoner) {
        return true
      }

      let found = false

      Object.values(this.specChoosenSizes).forEach((item) => {
        if (item && item.value && item.value.item) {
          found = true
        }
      })

      return found
    },
    useSpecifications: function () {
      if (this.isVin) {
        // No spec for vin
        return false
      } else if (this.form.Kategori) {
        // No spec for A-E
        const ae = ['A', 'B', 'C', 'D']

        return !ae.includes(this.form.Kategori.substring(0, 1))
      }

      return true
    },
    isAECategory: function () {
      if (this.form.Kategori) {
        // No spec for A-E
        const ae = ['A', 'B', 'C', 'D', 'E']

        return ae.includes(this.form.Kategori.substring(0, 1))
      }

      return false
    },
    isSentrum: function () {
      return this.form.Avdelingsid === 0 || this.form.Avdelingsid === '0'
    },
    isFornebu: function () {
      return this.form.Avdelingsid === 1 || this.form.Avdelingsid === '1'
    },
    isVin: function () {
      return this.form.Avdelingsid === 2 || this.form.Avdelingsid === '2'
    },
    merknadDropdownOptions: function () {
      let retval = []

      let eid = parseInt(this.form.Expertavdelingsid)

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: null, val: 'Laster...'})
      } else if (this.merknadDropdown.length > 0) {
        retval = this.merknadDropdown.filter((i) => {
          return i.Expertavdelingsid === eid
        })

        retval.unshift({key: null, val: 'Velg merknad'})
      } else {
        retval.unshift({key: null, val: 'Ingen merknad'})
      }

      return retval
    },
    fraktgruppeDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.form.Fraktgruppeid, val: 'Laster...'})
      } else if (!this.isVin) {
        retval = this.fgrDropdown.filter((i) => {
          return i.key !== 8 // Vin
        })
      } else {
        retval = this.fgrDropdown
      }

      return retval
    },

    // Expertavdeling Dropdown based on Avdeling
    expDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.form.Expertavdelingsid, val: 'Laster...'})
      } else if (this.form.Avdelingsid === null || this.form.Avdelingsid === '') {
        retval.unshift({key: null, val: 'Velg avdeling først'})
      } else {
        retval = this.expList.filter((i) => {
          return parseInt(i.Avdelingsid) === parseInt(this.form.Avdelingsid)
        })

        // HACK, HACK, HACK...
        const exists = retval.find(i => Number(i.key) === Number(this.form.Expertavdelingsid))
        if (!exists) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.form.Expertavdelingsid = null
        }

        if (retval.length < 1) {
          retval.unshift({key: null, val: 'Ingen ekspertavdeling'})
        } else {
          retval.unshift({key: null, val: 'Velg ekspertavdeling', disabled: true})
        }
      }

      return retval
    },

    // Kategori Dropdown based on Expertavdeling
    catDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.form.Kategori, val: 'Laster...'})
      } else if (this.form.Expertavdelingsid === null || this.form.Expertavdelingsid === '') {
        retval.unshift({key: null, val: 'Velg ekspertavdeling først'})
      } else {
        let eidIntVal = parseInt(this.form.Expertavdelingsid)

        retval = this.catList.filter((i) => {
          return i.expertavdelingsid.includes(eidIntVal)
        })

        if (retval.length < 1) {
          retval.unshift({key: null, val: 'Ingen kategori'})
        } else {
          retval.unshift({key: null, val: 'Velg kategori', disabled: true})
        }
      }

      return retval
    },
    kategoriSekundaerDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.form.KategoriSekundaer, val: 'Laster...'})
      } else if (this.form.Expertavdelingsid === null || this.form.Expertavdelingsid === '') {
        retval.unshift({key: null, val: 'Velg ekspertavdeling først'})
      } else {
        let eidIntVal = parseInt(this.form.Avdelingsid)
        retval = this.catList.filter((i) => {
          return i.avdelingsid === eidIntVal && i.key !== this.form.Kategori
        })

        retval.unshift({key: null, val: 'Ingen Sekundær Kategori'})
      }

      return retval
    },

    // Kategori Dropdown based on Avdeling
    avdelingCatDropdown: function () {
      let retval = []

      if (this.form.Avdelingsid === null || this.form.Avdelingsid === '') {
        retval.unshift({key: null, val: 'Velg avdeling først'})
      } else {
        retval = this.catList.filter((i) => {
          return parseInt(i.avdelingsid) === parseInt(this.form.Avdelingsid)
        })

        if (retval.length < 1) {
          retval.unshift({key: null, val: 'Ingen kategori'})
        } else {
          retval.unshift({key: null, val: 'Velg kategori', disabled: true})
        }
      }

      return retval
    },

    // Underkategori Dropdown Based on Kategori
    subCatDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.form.KategoriLabels, val: 'Laster...'})
      } else if (this.form.Kategori === null || this.form.Kategori === '') {
        retval.unshift({key: null, val: 'Velg hovedkategori først'})
      } else {
        // let pref = this.form.Kategori.slice(0, -1)
        let flat = this._.has(this.lblList, 'flat') && this.lblList.flat.length > 0 ? this.lblList.flat : []

        retval = flat.filter((i) => {
          return !i.parent
          // && i.kategori.slice(0, -1) === pref
        })

        if (retval.length < 1) {
          retval.unshift({key: null, val: 'Ingen underkategori'})
        } else {
          retval.unshift({key: null, val: 'Velg underkategori', disabled: true})
        }
      }

      return retval
    },

    // Kategori Dropdown Tree (Vin)
    subCatTreeDropdown: function () {
      var retval = []
      // let pref = this.form.Kategori.slice(0, -1)
      let tree = this._.has(this.lblList, 'tree') && this.lblList.tree.length > 0 ? this.lblList.tree : []

      // 62: Land
      // 63: Vintype
      tree.forEach((item) => {
        // Only Wine labels
        if (item.labeltype === 'V') {
          // && item.kategori.slice(0, -1) === pref) {
          let temp = {}
          temp.id = item.key
          temp.label = item.val

          // Add children
          if (item.children && item.children.length > 0) {
            // Disable top level
            temp.isDisabled = true
            temp.children = []
            this._appendChildren(temp.children, item.children)
          }

          retval.push(temp)
        }
      })

      return retval
    },
    tagOptionsTree: function () {
      let retval = []
      let tree = this._.has(this.lblList, 'tree') && this.lblList.tree.length > 0 ? this.lblList.tree : []

      tree.forEach((item) => {
        let temp = {}
        temp.id = item.key
        temp.label = item.val

        // Add children
        if (item.children && item.children.length > 0) {
          // Disable top level
          if (!item.parent && item.kategori) {
            temp.isDisabled = true
          }

          temp.children = []
          this._appendChildren(temp.children, item.children)
        }

        retval.push(temp)
      })

      return retval
    }
  },
  methods: {
    checkDisableAuksjonClear () {
      const el = document.querySelector('#objekt-section-0 div.vue-treeselect__x-container')
      if (el && this.isAuksjonDisabled) {
        el.classList.add('hide')
      }
    },
    onScrollStop: function (e) {
      const menu = window.jQuery('#myscrollmenu')
      let closest = null
      let curr = e.target.scrollTop
      let diff = 0

      window.jQuery('.scroll-section').each(function (idx) {
        let o = window.jQuery(this).position()

        if (closest === null) {
          closest = idx
          diff = Math.abs(curr - o.top)
        } else if (curr > o.top) {
          if (curr - o.top < diff) {
            diff = curr - o.top
            closest = idx
          }
        } else if (curr < o.top) {
          if (o.top - curr < diff) {
            diff = o.top - curr
            closest = idx
          }
        } else if (curr === o.top) {
          diff = 0
          closest = idx
        }
      })
      window.jQuery('a', menu).removeClass('active')
      window.jQuery('a.scroll-' + closest, menu).addClass('active')
    },
    myScrollTo: function (section) {
      const instance = this.$refs.myScrollBar.osInstance()
      const element = document.querySelector('#objekt-section-' + section)

      instance.scroll({ el: element, block: { y: 'begin', x: 'nearest' }, margin: { top: 50 } }, 750, 'easeInOutQuad')
    },
    onTagSearchInput: function (query) {
      query = query.replace(/,+/, ', ').replace(/ +/, ' ')

      let splitted = this.$helpers.explode(query, ',')
      let lastword = splitted.length > 0 ? splitted[splitted.length - 1] : ''

      let minuslast = splitted.filter((item, pos, arr) => {
        return pos < splitted.length - 1
      })

      let found = []

      this.tagList.find((tag) => {
        let val = this._.toLower(tag.val)
        if (val.includes(lastword) && !minuslast.includes(val)) {
          found.push(tag)
        }
      })

      return new Promise(resolve => {
        resolve({data: found})
      })
    },
    onTagSelected: function (item) {
      let value = this._.trim(item.val, ',')
      let splitted = this.$helpers.explode(this.form.tagsString, ',')

      splitted[splitted.length - 1] = value
      splitted = splitted.filter((item, pos, self) => {
        return self.indexOf(item) === pos
      })

      let str = splitted.join(', ')
      str = this._.trim(str, ', ') + ', '

      this.form.tagsString = str
    },
    // Append children for the tree multi select
    _appendChildren: function (retval, array) {
      array.forEach((item) => {
        let temp = {}
        temp.id = item.key
        temp.label = item.val

        // Add children?
        if (item.children && item.children.length > 0) {
          temp.children = []

          this._appendChildren(temp.children, item.children)
        }

        retval.push(temp)
      })
    },
    // Underavdeling Dropdown for selected category
    subCatDropdownByCat: function (selectedCat) {
      let retval = []

      if (selectedCat === null || selectedCat === '') {
        retval.unshift({key: null, val: 'Velg kategori først'})
      } else {
        // let pref = selectedCat.slice(0, -1)
        let flat = this._.has(this.lblList, 'flat') && this.lblList.flat.length > 0 ? this.lblList.flat : []

        retval = flat.filter((i) => {
          return !i.parent
          // && i.kategori.slice(0, -1) === pref
        })

        if (retval.length < 1) {
          retval.unshift({key: null, val: 'Ingen underkategori'})
        } else {
          retval.unshift({key: null, val: 'Velg underkategori', disabled: true})
        }
      }

      return retval
    },

    toggleSpecPopover: function () {
      if (!this.isPresenceOwner) {
        return
      }

      this.specPopoverActive = !this.specPopoverActive
    },
    addSpecSizeItem: function (item) {
      if (!this.isPresenceOwner) {
        return
      }

      this.$set(this.specChoosenSizes, item.name, {name: item.name, label: item.label, value: {item: '', picker: item.defaultUnit ? item.defaultUnit : 0}})

      // Now set new element in focus
      setTimeout(function () {
        window.jQuery('input[name=' + CSS.escape(item.name) + ']').focus()
      })
    },
    delSpecSizeItem: function (index) {
      if (!this.isPresenceOwner) {
        return
      }

      this.$delete(this.specChoosenSizes, index)
    },
    makeFormItem: function () {
      let defaults = {
        Expertavdelingsid: this.objekt.kategori ? this.objekt.kategori.Expertavdelingsid : null,
        KategoriLabels: this.isVin ? [] : null,
        AddonKategoriList: [],
        // Tags: [],
        signert: null,
        tagsString: ''
      }

      // Apply default values
      this.$helpers.setObjectValues(defaults, this.objekt)

      // Clone kontrakt to the form object
      this.form = this._.cloneDeep(this.objekt)

      if (this.objekt.Kategori === 'GL' && !this.objekt.NettMerknad) {
        this.$set(this.form, 'NettMerknad', 'The movement is running at the time of cataloguing, but has not been inspected. Blomqvist does not guarantee the accuracy or future working of the movement. Inspection/service recommended. Unless stated, no papers, warranties, parts or original box is included with the lot.')
      } else {
        this.$set(this.form, 'NettMerknad', this.objekt.NettMerknad)
      }

      this.$set(this.form, 'Lev_dato', this.objekt.Lev_dato ? new Date(Date.parse(this.objekt.Lev_dato)) : null)

      /**
       * Parse and make data for the Tags / Kategori / Label things...
       */

      // 1. Tags as an array of id's
      // this.form.Tags = this._.flatMap(this.objekt.objekttag || [], function (i) { return i.Labelid }) || []
      let tagIds = this._.flatMap(this.objekt.objekttag || [], function (i) { return i.Labelid }) || []

      if (this.isVin) {
        // 2. If vin: kategori labels as array of id's
        this.form.KategoriLabels = this._.flatMap(this.objekt.objektlabel || [], function (i) { return i.Labelid }) || []
      } else {
        // 2. If NOT vin: start by getting an array of id's
        let mainLabels = this._.flatMap(this.objekt.objektlabel || [], function (i) { return i.Labelid }) || []

        // If we got an array - we take the first item as kategori label
        if (mainLabels.length > 0) {
          this.form.KategoriLabels = mainLabels[0]
        }

        // If we got even more labales from database, we append it to the tags
        if (mainLabels.length > 1) {
          let rest = mainLabels.splice(1)

          if (typeof rest === 'object') {
            rest.forEach((i) => {
              tagIds.push(i)
            })
          } else {
            tagIds.push(rest)
          }
        }

        // Create the tags...
        if (tagIds.length > 0) {
          let found = null
          let array = []
          tagIds.forEach((tagLabelId) => {
            found = this.tagList.find((i) => i.key === tagLabelId)

            if (found) {
              array.push(found.val)
            }
          })

          this.form.tagsString = array.join(', ')
        } else {
          this.form.tagsString = ''
        }

        // 3. Create the initial addon kategori list...
        if (this.objekt.objektkategori && this.objekt.objektkategori.length > 0) {
          // Loop all kategori items
          this.objekt.objektkategori.forEach((i) => {
            if (i.objektkategorilabel && i.objektkategorilabel.length > 0) {
              // If we have an array of kategori labels, we add kategori/label to array
              i.objektkategorilabel.forEach((l) => {
                this.form.AddonKategoriList.push({Kategori: i.Kategori, KategoriLabels: l.Labelid})
              })
            } else {
              // No labels, so we just add kategori to array
              this.form.AddonKategoriList.push({Kategori: i.Kategori, KategoriLabels: ''})
            }
          })
        }
      }

      // Set signert...
      this.sigDropdown.forEach(item => {
        if (this._.startsWith(this.form.Objekt1, item.val)) {
          this.form.signert = item.key
        }
      })

      // And lastly set the specifications...
      this.specFromObjekt()

      // Make copy of form as original - will be used to check if form has changed
      this.original = this._.cloneDeep(this.form)
      this.originalSpec = this._.cloneDeep(this.specChoosenSizes)

      // Need to convert null values to empty string
      this._.map(this.original, (value) => {
        return value === null ? '' : value
      })
    },
    specFromObjekt: function () {
      Object.keys(this.specOptionsSizes).forEach((e) => {
        let pickerValue = this.specOptionsSizes[e].hasOwnProperty('defaultUnit')
          ? this.specOptionsSizes[e].defaultUnit
          : 0

        if (this.form.hasOwnProperty(e) && this.form[e]) {
          // this.$set(this.specChoosenSizes, e, this.form[e])

          if (this.specOptionsSizes[e].unitOptions && this.form.hasOwnProperty(e + '_Enhet') && this.form[e + '_Enhet']) {
            pickerValue = this.specOptionsSizes[e].unitOptions.findIndex(i => i === this.form[e + '_Enhet'])
          }

          this.$set(this.specChoosenSizes, e, { name: e, label: this.specOptionsSizes[e].label, value: {item: this.form[e], picker: pickerValue} })
        } else if (this.specOptionsSizes[e].expertavdeling.includes(this.form.Expertavdelingsid)) {
          this.$set(this.specChoosenSizes, e, { name: e, label: this.specOptionsSizes[e].label, value: {item: '', picker: pickerValue} })
        }
      })
    },
    specToObjekt: function () {
      Object.keys(this.specOptionsSizes).forEach((e) => {
        if (this.specChoosenSizes.hasOwnProperty(e) && this.specChoosenSizes[e]) {
          this.$set(this.form, e, this.specChoosenSizes[e].value.item)

          if (this.specOptionsSizes[e].unitOptions && this.specOptionsSizes[e].unitOptions.length > 0) {
            this.$set(this.form, e + '_Enhet', this.specOptionsSizes[e].unitOptions[this.specChoosenSizes[e].value.picker])
          }
        } else {
          this.$set(this.form, e, null)

          if (this.specOptionsSizes[e].unitOptions && this.specOptionsSizes[e].unitOptions.length) {
            this.$set(this.form, e + '_Enhet', null)
          }
        }
      })
    },

    fetch: function () {
      const skipCategories = ['US', 'ZS']

      this.objDropdown.unshift({key: this.form.Objekttype, val: 'Laster...'})
      this.avdDropdown.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      this.fgrDropdown.unshift({key: this.form.Fraktgruppeid, val: 'Laster...'})

      this.lokDropdown.unshift({key: this.form.Lokasjonid, val: 'Laster...'})
      this.sigDropdown.unshift({key: this.form.signert, val: 'Laster...'})

      this.merknadDropdown.unshift({key: null, val: 'Laster...'})

      ObjektService.loadFormDropdowns()
        .then((response) => {
          this.avdDropdown = response.avdeling
          this.avdDropdown.unshift({key: null, val: 'Velg avdeling', disabled: true})

          if (this.form.Avdelingsid === 3) {
            this.objDropdown = response.objekttype.filter(type => type.key === 'K')
          } else {
            this.objDropdown = response.objekttype
          }
          this.objDropdown.unshift({key: null, val: 'Velg objekttype', disabled: true})

          this.fgrDropdown = response.fraktgruppe.filter(el => {
            return el.passiv === 'F'
          })

          this.fgrDropdown.unshift({key: null, val: 'Kan ikke sendes'})

          this.lokDropdown = response.lokasjon
          // this.lokDropdown.unshift({key: null, val: 'Velg lokasjon', disabled: true})

          this.sigDropdown = response.objektsignert
          this.sigDropdown.unshift({key: null, val: 'Velg signeringssted'})

          this.merknadDropdown = response.merknad
          this.merknadDropdown.unshift({key: null, val: 'Velg Merknad'})

          this.expList = response.expertavdeling
          this.catList = response.kategori.filter(c => !skipCategories.includes(c.key))
          this.lblList = response.label
          this.tagList = response.tag
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
          this.makeFormItem()
        })
    },
    handleSubmit: function (data) {
      if (!this.isPresenceOwner) {
        return
      }

      if (data.status !== undefined) {
        this.form.Tekst_ok = data.status === true ? 'T' : 'F'
      }

      if (this.form.Tekst_ok === 'T') {
        this.handleSubmitWithValidation(data.closeAfterSave)
      } else {
        this.handleSubmitWithoutValidation(data.closeAfterSave)
      }
    },
    handleSubmitWithoutValidation: function (closeAfterSave) {
      if (!this.isPresenceOwner) {
        return
      }

      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.save(closeAfterSave)
    },

    handleSubmitWithValidation: function (closeAfterSave) {
      if (!this.isPresenceOwner) {
        return
      }

      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.save(closeAfterSave)
          }
        })
    },

    save: function (closeAfterSave) {
      if (!this.isPresenceOwner) {
        return
      }

      // The holders of objektlabels and kategori/labels
      this.form.tags = []
      this.form.objektlabel = []
      this.form.objektkategori = []

      // Make tags
      if (this.form.tagsString) {
        let found = null
        let array = this.$helpers.explode(this.form.tagsString, ', ')

        if (array && array.length > 0) {
          array.forEach((value) => {
            found = this.tagList.find((i) => this._.toLower(i.val) === this._.toLower(value))

            if (found) {
              this.form.tags.push({Labelid: found.key})
            } else {
              this.form.tags.push({Navn: value, labeltype: this.isVin ? 'V' : 'K'})
            }
          })
        }
      }

      // Fix textarea values - trim the values
      if (this.form.Objekt1) {
        this.form.Objekt1 = this.form.Objekt1.trim()
      }
      if (this.form.Objekt3) {
        this.form.Objekt3 = this.form.Objekt3.trim()
      }
      if (this.form.Katalogtekst2) {
        this.form.Katalogtekst2 = this.form.Katalogtekst2.trim()
      }
      if (this.form.NettMerknad) {
        this.form.NettMerknad = this.form.NettMerknad.trim()
      }
      if (this.form.Rettelse) {
        this.form.Rettelse = this.form.Rettelse.trim()
      }

      // Unless lokasjon is set to Utlevert -> we set Lev_dato to null
      if (!(this.form.Lokasjonid === '159' || this.form.Lokasjonid === 159 || this.form.Lokasjonid === '327' || this.form.Lokasjonid === 327)) {
        this.$set(this.form, 'Lev_dato', null)
        this.$set(this.form, 'Lokasjon', '')
      } else {
        this.$set(this.form, 'Lokasjon', '<utlevert>')
      }

      // Add choosen spec to the form data, so we save them
      this.specToObjekt()

      // Wine
      if (this.isVin) {
        console.log('Wine saving')
        if (this.form.KategoriLabels) {
          this.form.KategoriLabels.forEach((i) => {
            this.form.objektlabel.push({Labelid: parseInt(i)})
          })
        }
      } else {
        console.log('NOT Wine saving')
        if (this.form.KategoriLabels) {
          this.form.objektlabel.push({Labelid: parseInt(this.form.KategoriLabels)})
        }

        // Group by Katagori
        var grouped = {}

        this.form.AddonKategoriList.forEach((i) => {
          // Skip if empty
          if (i.Kategori === null) {
            return
          }

          if (!grouped.hasOwnProperty(i.Kategori)) {
            grouped[i.Kategori] = []
          }

          if (i.KategoriLabels && i.Kategori) {
            let addme = {Labelid: parseInt(i.KategoriLabels)}

            if (this._.find(grouped[i.Kategori], addme) === undefined) {
              grouped[i.Kategori].push(addme)
            }
          }
        })

        // And now add to the save data
        if (!this._.isEmpty(grouped)) {
          this._.forEach(grouped, (value, index) => {
            this.form.objektkategori.push({ Kategori: index, objektkategorilabel: value })
          })
        }
      }

      // Take only unique entries
      this.form.objektlabel = this._.uniqWith(this.form.objektlabel, this._.isEqual)
      this.form.objektkategori = this._.uniqWith(this.form.objektkategori, this._.isEqual)

      if (!this.form.Fraktgruppeid) {
        this.form.Kansendes = 'F'
      } else {
        this.form.Kansendes = 'T'
      }

      // Clone form to data
      let data = this._.clone(this.form)

      data.Lev_dato = this.form.Lev_dato ? moment(new Date(this.form.Lev_dato)).format('YYYY-MM-DD') : null

      // Append signert to Objekt1 if has it.
      if (!this._.isEmpty(this.signertText)) {
        data.Objekt1 = this.signertText + ' ' + data.Objekt1
      }

      // Todo: just send the values that are needed. For now, remove some of the keys...
      const removeKeys = ['Tilslagnr', 'Salgspris', 'Mottaker', 'mottaker']
      removeKeys.forEach(k => {
        if (data.hasOwnProperty(k)) {
          delete data[k]
        }
      })

      KundeService.saveKundeKontraktObjekt(this.kunde.Kundenr, this.kontrakt.Kontraktnr, this.form.Objektid, data)
        .then((response) => {
          // Show success alert
          this.$helpers.showSuccessAlert('Objekt er lagret')

          this.lastLokId = Number(data.Lokasjonid)
          localStorage.new_obj_lokasjonid = data.Lokasjonid

          if (this.isVin) {
            if (data.Fraktgruppeid) {
              console.log('Save last fraktgruppe', data.Fraktgruppeid)
              localStorage.setItem('last-invoice-group-wine', data.Fraktgruppeid)
            } else {
              console.log('Remove last fraktgruppe')
              localStorage.removeItem('last-invoice-group-wine')
            }
          }

          // Emit event so we can update list
          bus.$emit('objekt-modal-update', response.data)
          bus.$emit('kunde-kontrakt-objekt-updated', response.data)

          if (closeAfterSave) {
            bus.$emit('close-objekt-edit')
          }
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
          }
        })
        .then(() => {
          this.setFormProcessing(false)
          this.setFormDirty(false)
        })
    },

    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.Avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.form.Auksjon = item.Auksjon || ''
      }
    },
    onAuksjonSaved: function (item) {
      this.form.Auksjon = item.Auksjon || ''
    },
    openAuksjonModal: function (item) {
      if (item) {
        this.openModal('auksjon-form-modal', {auksjonIdentifier: item})
      } else {
        this.openModal('auksjon-form-modal')
      }
    },

    onKunstnerSearchInput: function (query) {
      return new Promise(resolve => {
        KunstnerService.search(query, 1)
          .then((response) => {
            const found = response.data.map(x => {
              return { key: x.Idnr, val: x.name_original, period: x.period_dates || '' }
            })

            resolve({ data: found })
          })
      })

      // Old
      // return KunstnerService.search(query)
    },
    onKunstnerSearchSelected: function (item) {
      if (!item) {
        this.form.Kunstnerid = null
      } else {
        this.form.Kunstner = item.val || ''
        this.form.Kunstnerid = item.key || null
      }
    },
    onKunstnerSaved: function (item) {
      this.form.Kunstner = item.Navn || ''
      this.form.Kunstnerid = item.Idnr || null
    },
    onKunstnerReset: function () {
      this.form.Kunstner = null
      this.form.Kunstnerid = null
    },
    openKunstnerModal: function (item) {
      if (item) {
        if (this.form.Kunstnerid) {
          this.openModal('kunstner-form-modal', {kunstnerIdentifier: this.form.Kunstnerid})
        } else {
          this.$helpers.showErrorAlert('Feil', 'Du kann ikke rediger en kunstner som ikke er lagret i databasen')
        }
      } else {
        this.openModal('kunstner-form-modal')
      }
    },
    checkVurdering: function (value) {
      return new Promise(resolve => {
        let low = parseInt(this.form.Vurderingspris2)
        let high = parseInt(this.form.Vurderingspris1)

        if (low > 0 && high > 0) {
          if (low >= high) {
            resolve({ valid: false, data: { message: 'Høy vurdering er lavere eller lik lav vurdering' } })
            return
          }
        }

        resolve({ valid: true })
      })
    },
    checkMinstepris: function (value) {
      return new Promise(resolve => {
        let low = parseInt(this.form.Vurderingspris2)
        let val = value !== '' && value !== null ? parseInt(value) : null

        if (!low) {
          resolve({ valid: true })
        } else if (val === null) {
          resolve({ valid: false, data: { message: 'Minstepris er obligatorisk' } })
        } else if (val > low) {
          resolve({ valid: false, data: { message: 'Minstepris er høyere enn lav vurdering' } })
        } else {
          resolve({ valid: true })
        }
      })
    }
  }
}
</script>
<style scoped>
/* ::-webkit-scrollbar{
    all:unset;
}

::-webkit-scrollbar-track-piece{
    all:unset;
} */
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektForm.vue